<template>
    <transition>
        <section>
            <div class="AboutSection">
            
                <div>
                    <div class="AboutSection-p" >
                      
                    <span>“每日推荐名企名校让你砰然心动的TA </span>
                    <span>在月娘很高兴认识你</span>
                     <div class="AboutSection-lxed">  &nbsp;&nbsp;&nbsp;&nbsp;月娘婚恋是一款以“线下活动”为核心的婚恋平台，致力于为海量同城优质单身青年，通过线上报名“活动”，
                        通过线下活动解决用户单身、社交圈窄、破冰线上转线下见到真实的另一半
                        。将志趣相投的精英人群汇聚在一起，通过私密安全的环境及丰富的趣味活动主题
                        ，为更多单身优质人士提供更具有品质的灵魂体验。</div>

                        <div  class="aldller">
                            <!-- <img class="AboutSection-xler" src="../../img/2222.gif" alt="">  -->
                            <v-img
                 class="AboutSection-imgder"
       
                lazy-src="https://test-cos.ynhlminiapp.com/bb252eb4-b897-4b62-9c83-97c77124ae7c.png"
                src="https://test-cos.ynhlminiapp.com/bb252eb4-b897-4b62-9c83-97c77124ae7c.png"
                cover
              ></v-img>
                        </div>
                      
              
                       
                    </div>
                </div>
            </div>

     
        </section>
    </transition>

</template>

<script>
import { add } from "../utils/deta.js";
import {WonderfulAtlasList } from '../axios/dev'
// v-for="item in formlist" :key="item.teacherId"  @mouseenter.stop="handleMouseEnter(item)" @mouseleave.stop="handleMouseLeave(item)"
export default {
    data() {
        return {
            testShowxr: false,
            tab: 'tab-1',
      tabs: [
        {
          icon: 'mdi-book-open-page-variant',
          text: 'Readme',
          value: 'tab-1',
        },
        {
          icon: 'mdi-handshake-outline',
          text: 'Code of Conduct',
          value: 'tab-2',
        },
        {
          icon: 'mdi-license',
          text: 'MIT License',
          value: 'tab-3',
        },
        {
          icon: 'mdi-shield-lock-outline',
          text: 'Security',
          value: 'tab-4',
        },
      ],
            formlist: [],



        }
    },


    mounted() {
        // this.scrollInit();
        // this.add()
        // WonderfulAtlasList({
        //     contentType:2,
        //     size:20,
        //     current:1
        //   }).then(res=>{
        //     // console.log(res);
        //      this.formlist=res.data.list


        //    })
    },
    methods: {
        handleMouseEnter(item) {
            item.show = true
        },
        handleMouseLeave(item) {
            item.show = false

        },
        scrollInit() {
            // 获取要绑定事件的元素
            const nav = document.getElementById("nav")
            var flag; // 鼠标按下
            var downX; // 鼠标点击的x下标
            var scrollLeft; // 当前元素滚动条的偏移量
            nav.addEventListener("mousedown", function (event) {
                flag = true;
                downX = event.clientX; // 获取到点击的x下标
                scrollLeft = this.scrollLeft; // 获取当前元素滚动条的偏移量
            });
            nav.addEventListener("mousemove", function (event) {
                if (flag) { // 判断是否是鼠标按下滚动元素区域
                    var moveX = event.clientX; // 获取移动的x轴
                    var scrollX = moveX - downX; // 当前移动的x轴下标减去刚点击下去的x轴下标得到鼠标滑动距离
                    this.scrollLeft = scrollLeft - scrollX // 鼠标按下的滚动条偏移量减去当前鼠标的滑动距离
                    console.log(scrollX)
                }
            });
            // 鼠标抬起停止拖动
            nav.addEventListener("mouseup", function () {
                flag = false;
            });
            // 鼠标离开元素停止拖动
            nav.addEventListener("mouseleave", function (event) {
                flag = false;
            });
        },



        // timestampToTime


        // 时间戳转换函数


        // 示例使用
        // 输出：2021-05-26 16:11:25

    },


}
</script>

<style scoped>
.AboutSection {
    width: 100%;
    height: 800px;
    /* background-color: red; */
    background: linear-gradient(360deg, #F5F3FF 50%, rgba(204, 190, 255, 0) 100%);
    /* border: 1px solid #ccc; */
    margin-top: 50px;
    /* background-color: #F1EEFF; */
}

.AboutSection-one {
    margin: 20px auto;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 56px;
    color: #051850;
    line-height: 82px;
    text-align: center;
    font-style: normal;

}

.AboutSection-Single {

    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.1);
    margin-top: -35px;
    letter-spacing: 6px;
    text-align: center;
    font-style: normal;
    text-transform: uppercase;
}

.AboutSection-two {

    /* margin: 0px auto;  */
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    margin-top: 10px;
    /* border: 1px solid #ccc; */
    color: #999;
    line-height: 33px;
    text-align: center;
    font-style: normal;


}

.AboutSection-p {
    width: 100%;
    height: 624px;
    /* overflow: hidden; */
    /* background-color: rebeccapurple; */
    position: relative;
    display: flex;
}
.AboutSection-p span:nth-child(1){
    width: 40%;
    height: 60px;
     overflow: hidden;

    font-family: AlibabaPuHuiTiM;
font-size: 46px;
color: #333333;
line-height: 63px;
margin-left: 302px;
margin-top: 150px;
/* text-align: left; */
font-style: normal;
}
.AboutSection-p span:nth-child(2){
    font-family: AlibabaPuHuiTiM;
font-size: 46px;
color: #783DF9;
position: absolute;
top: 220px;
left: 342px;
font-style: normal;
}
.AboutSection-xsl {
    width: 780px;
    /* height: 100%; */
    /* border: 1px solid forestgreen; */
    display: flex;
    flex-wrap: wrap;
    position: relative;

}
.AboutSection-lxed{
    width: 484px;
    height: 195px;
    font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 16px;
color: #999999;
line-height: 39px;
text-align: justify;
font-style: normal;
position: absolute;
top: 300px;
left: 342px;
}


.AboutSection-ers {
    width: 360px;
    height: 300px;
    border-radius: 10px;

    margin-left: 20px;
    text-align: center;
    position: relative;
    /* border: 1px solid #ccc; */
}



/* .AboutSection-xler{
    width: 748px;
    height: 749px;
   
} */
.AboutSection-imgder{
    width: 141px;
    height: 141px;
    position: absolute;
    top: 380px;
    left: 18%;

}
.aldller{
    width: 748px;
    height: 749px;
    background-color: saddlebrowns;
      background:url('../../img/2222.gif') no-repeat center 0px ;
	   background-position: center 0px;
      background-size: cover;
      position: relative;
   
}
</style>